import React, {useEffect, useState} from "react"
import { Product } from "../profile/Profile";
import { Link } from "react-router-dom";
import firebase from "../firebase";
const storage = firebase.storage();

export interface ProductProps {
  product: Product;
}
export interface ProductsProps {
  products: Product[];
}

export const ProductPreview = ({product}: ProductProps) => {
  const [imageUrl, setImageUrl] = useState<string>(null as unknown as string);
  useEffect(() => {
    if (product && product.productData && product.productData.img) {
      storage
        .ref(product.productData.img)
        .getDownloadURL()
        .then((response) => {
          setImageUrl(response);
        })
        .catch((err) => {
          // Didn't exist... or some other error
        });
    }
  }, [product]);

  return (
    <div className='product-card'>
      {imageUrl && <img src={imageUrl} alt="product" /> }
      <div className="product-name">{product.productData.name}</div>
    </div>
  )
}

export const ProductList = ({ products }: ProductsProps) => {
  const listItems = products.map((product) =>
    <Link key={product.id} to={`/products/edit/${product.id}`}>
      <ProductPreview product={product}/>
    </Link>
  );

  return (
    <div className="product-list">
      {listItems}
    </div>
  );
}

